import React from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Services from './pages/Services/Services';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Quiz from './pages/Quiz/Quiz';
import NotFound from './pages/NotFound/NotFound';
import './App.scss';

class App extends React.Component {
	constructor(props) {
	  super(props);
	  this.state = {
		journey: {
			sessions: [{
				start: {
					pathname: this.props.location.pathname,
					search: this.props.location.search ? this.props.location.search : undefined,
					timestamp: new Date().getTime()
				},
				timeline: [],
				ellipsis: false
			}],
			lastWrite: new Date().getTime()
		},
	  };
	};

	// Change page Title
	changePageTitle(location) {
		const pageTitle = location ? `${location.charAt(0).toUpperCase()+location.slice(1)} | Laboratorio Dorronsoro` : 'Laboratorio Dorronsoro';
		document.title = pageTitle;
	}

	componentDidMount() {
		// Preloader
		this.props.hideLoader();
	};

	componentDidUpdate() {
		const pathname = this.props.location.pathname;

		// Change page Title
		this.changePageTitle(pathname.replace('/', ''));

		// Journey
		const newLocation = {
			pathname,
			search: this.props.location.search ? this.props.location.search : undefined,
			timestamp: new Date().getTime()
		}
		let journey = Object.assign({}, this.state.journey);
		let lastSession;
		let addLocation = false;

		if (journey.sessions.slice(-1).pop()) {
			lastSession = journey.sessions.slice(-1).pop();

			if (lastSession.timeline.slice(-1).pop()) {
				const lastLocation = lastSession.timeline.slice(-1).pop();
	
				if (lastLocation.pathname !== newLocation.pathname) {
					addLocation = true;
				}
			} else if (lastSession.timeline.length === 0) {
				addLocation = true;
			}
		}

		if (addLocation) {
			journey.lastWrite = newLocation.timestamp;
			lastSession.timeline = [...lastSession.timeline, newLocation];

			if(lastSession.timeline.length > 10) {
				lastSession.timeline.shift();
				lastSession.ellipsis = true;
			}

			this.setState({journey});
		}
	}

	render() {
		return (
		<React.Fragment>
			{/* {!this.props.location.pathname.includes("/encuesta") && <Header />} */}
			<Header />
			<Switch>
				<Route
					exact
					path='/'
					component={Home}
				/>
				<Route
					path='/servicios'
					component={Services}
				/>
				<Route
					path='/nosotros'
					component={About}
				/>
				<Route
					path='/contacto'
					component={Contact}
				/>
				<Route
					path='/encuesta'
					component={Quiz}
				/>
				<Route
					path='/404'
					component={NotFound}
				/>
    			<Redirect to="/404" />
			</Switch>
			<Footer />
		</React.Fragment>
		);
	}
}

export default withRouter(App);
